import React from 'react';
import { isDev as isDevEnv } from './env';

export function timeConvert(originalTime) {
  const elements = originalTime.split(':');
  const hours = elements[0];
  const min = elements[1];

  let adjustedHours = hours;
  let tag = 'AM';
  if (hours > 12) {
    adjustedHours = hours - 12;
    tag = 'PM';
  } else {
    adjustedHours = parseInt(hours, 10);
    if (adjustedHours === 0) {
      adjustedHours = 12;
    }
  }

  return `${adjustedHours}:${min} ${tag}`;
}

export function errorDisplay(errors) {
  console.error(errors);

  const errorString = JSON.stringify(errors, null, 1).replace(
    /[[\]{}",]+/g,
    ''
  );
  const errorString2 = errorString.replace(/\s\s+/g, '=');
  console.log(errorString2);
  const errorArr = errorString2.split('=');
  const errorDisplay = errorArr.map((e, index) => {
    console.log(typeof e[0]);

    if (
      e !== '' &&
      !e.startsWith('status:') &&
      !e.startsWith('statusText:') &&
      e[0] !== '0' &&
      !parseInt(e[0])
    ) {
      if (e.endsWith(':')) {
        return (
          <React.Fragment key={index}>
            <span className="text-bold">{e}</span>
            <br />
          </React.Fragment>
        );
      } else {
        return (
          <React.Fragment key={index}>
            {e}
            <br />
          </React.Fragment>
        );
      }
    } else {
      return '';
    }
  });

  return (
    <React.Fragment>
      <div>{errorDisplay}</div>
    </React.Fragment>
  );
}

export function redirect(action, url) {
  const navigate = action.meta.navigate; // This is the navigate function passed from React Router v6
  // // by passing this through the actions the interface can be redirected in the middleware
  // // without having to use an integration between react-router and redux.

  if (action.previous) {
    url = action.previous;
  }
  if (action.meta.formSteps) {
    const steps = action.meta.formSteps;
    if (steps.nextSteps.length > 0) {
      const type = steps.type;
      const upNext = steps.nextSteps[0];
      const nextArr = [...steps.nextSteps];
      nextArr.splice(0, 1);
      const nextSteps = nextArr.join();
      const prevArr = [...steps.prevSteps];
      const prevSteps = prevArr.join();
      url = `/${type}/${steps.id}/edit/?mode=${upNext}&next=${nextSteps}&past=${prevSteps}`;
    } else if (action.meta.previous) {
      url = action.meta.previous;
    }
  } else if (action.meta.previous) {
    url = action.meta.previous;
  }
  if (navigate) {
    // For React Router v6, we need to pass state explicitly
    const navigationState = {};

    if (action.meta.componentOptions) {
      Object.assign(navigationState, action.meta.componentOptions);
    }
    
    // If this is a formSteps navigation, include previous info
    if (action.meta.formSteps && action.meta.formSteps.nextSteps.length > 0) {
      navigationState.previous = action.meta.previous || url.replace(/\/edit\/.*/, '');
    }
    
    // Navigate with state if we have any, otherwise just navigate with URL
    if (Object.keys(navigationState).length > 0) {
      navigate(url, { state: navigationState });
    } else {
      navigate(url);
    }
  }
}

// Function to create a CSV file for download from data
// Expects an array of arrays for each row in the sheet
// and an array of header names
// Returns the data encoded as a url for download

export function CSVFromHeaderAndDataArray(arrayHeader, arrayData) {
  //Takes the arrays of fields and turns them into comma-separated lines with double quotes if necessary to
  //escape any special chars.
  //console.log(arrayHeader, arrayData);
  //arrayData is an array of arrays. Each sub-array represents one row of fields.
  let header = arrayHeader.join() + '\n';
  let csv = header;
  arrayData.forEach((rowArray) => {
    //Convert the row of fields into the same set of fields but possibly with the correct syntax for escaping
    //special characters like embedded commas
    const csvFormattedArray = rowArray.map((term) => {
      return escapeCSV(term);
    });
    //Add the escaped rowArray to the growing string of lines
    csv += csvFormattedArray.join() + '\n';
  });
  return csv;
}

export function createCSV(arrayHeader, arrayData, fileName) {
  const csv = CSVFromHeaderAndDataArray(arrayHeader, arrayData);
  let csvData = new Blob([csv], { type: 'text/csv' });
  // return URL.createObjectURL(csvData);
  const csvUrl = URL.createObjectURL(csvData);

  let hiddenElement = document.createElement('a');
  hiddenElement.href = csvUrl;
  hiddenElement.target = '_blank';
  hiddenElement.download = fileName + '.csv';
  hiddenElement.click();
}

export const required = (value) =>
  value ? undefined : 'This field is required';

export const zeroPad = (string, width) => {
  //Pad string with leading zeros up to width
  //Prepend zeros and then take the last width chars
  //example: string="25", width=5
  //    full string = 0000025
  //    returned string = 00025
  return ("0".repeat(width) + string).slice(-width)
}

export const monthNameFromNumber = (monthNumber) => {
  //monthNumber is zero-based
  const month = [];
  month[0] = "January"
  month[1] = "February"
  month[2] = "March"
  month[3] = "April"
  month[4] = "May"
  month[5] = "June"
  month[6] = "July"
  month[7] = "August"
  month[8] = "September"
  month[9] = "October"
  month[10] = "November"
  month[11] = "December"
  if (monthNumber >= 0 && monthNumber <= 11) {
    return month[monthNumber]
  }
  return "unknown-month(" + monthNumber + ")"
}

export function datetimeForCsv(dateobj) {
  //Convert datetime object to format May 21, 2021 13:05:06
  const dayOfMonth = zeroPad(dateobj.getDate(), 2)
  const year = dateobj.getFullYear()
  const monthName = monthNameFromNumber(dateobj.getMonth())
  const hours = zeroPad(dateobj.getHours(), 2)
  const minutes = zeroPad(dateobj.getMinutes(), 2)
  const seconds = zeroPad(dateobj.getSeconds(), 2)
  return `${monthName} ${dayOfMonth}, ${year} ${hours}:${minutes}:${seconds}`;
}

export function intlDatetimeForCsv(dateobj, intl) {
  if (dateobj === null || dateobj.toString() === 'Invalid Date') {
    return '' //return empty string if dateobj is undefined or invalid
  }
  const formattedDate = intl.formatDate(dateobj, {
    month: 'long',
    day: '2-digit',
    year: 'numeric',
  });

  const formattedTime = intl.formatTime(dateobj, {
    hour12: true,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }) 

  return `${formattedDate} ${formattedTime}`;
}

export function escapeCSV (term) {
  //Prep the input string for saving as a CSV field
  //Leave as-is if the string does not have any special characters requiring escaping
  if (term && term.match && term.match(/,|"/))  {
    return `"${term.replace(/"/g, '""')}"`
  } else {
    return term
  }
}

export const isDev = isDevEnv;